import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useCity } from "../context/CityContext";

import createPlusicon from "../ui-assets/home/create-event-plus.svg";
import searchicon from "../ui-assets/home/search.svg";
import detecticon from "../ui-assets/home/detect-icon.svg";
import locationIcon from "../ui-assets/home/location.svg";
import { API_BASE_URL } from "../config";

const MainHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const { selectedCity, setSelectedCity } = useCity();

  const [showLocationModal, setShowLocationModal] = useState(false);
  const [cities, setCities] = useState([]);
  const [citySearch, setCitySearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showAllCities, setShowAllCities] = useState(false);
  const [allCities, setAllCities] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [eventResults, setEventResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const modalRef = useRef(null);

  const handleSignIn = () => {
    setMobileMenuOpen(false);
    navigate("/signin");
  };
  const handleCreateEvent = () => {
    setMobileMenuOpen(false);
    navigate("/create-event");
  };

  useEffect(() => {
    if (!showLocationModal) return;

    fetch(`${API_BASE_URL}/getMetroCities`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.status === "success") {
          setCities(data.data);
        }
      })
      .catch((err) => console.error("City API error:", err));
  }, [showLocationModal]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setShowLocationModal(false);
      }
    };

    if (showLocationModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLocationModal]);

  useEffect(() => {
    if (!citySearch.trim()) {
      setSearchResults([]);
      return;
    }
    const timeout = setTimeout(() => {
      fetch(
        `${API_BASE_URL}/getCities?searchbyCity=${citySearch}`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status === "success") setSearchResults(data.data);
        })
        .catch((err) => console.error("City search error:", err));
    }, 100);
    return () => clearTimeout(timeout);
  }, [citySearch]);


  useEffect(() => {
    if (searchText.trim().length < 2) {
      setEventResults([]);
      setShowSearchDropdown(false);
      return;
    }

    const timer = setTimeout(async () => {
      setSearchLoading(true);

      try {
       const city = selectedCity || "";

const res = await fetch(
  `${API_BASE_URL}/search_events?q=${encodeURIComponent(searchText)}&city=${encodeURIComponent(city)}`
);

       const data = await res.json();

console.log("Search API:", data);

setEventResults(Array.isArray(data.result) ? data.result : []);
setShowSearchDropdown(true);
      } catch (err) {
        console.log(err);
      }

      setSearchLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);





  const handleSelectCity = (cityName) => {
    setSelectedCity(cityName);
    setShowLocationModal(false);
    setCitySearch("");
    setSearchResults([]);
    setShowAllCities(false);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleAllCities = () => {
    setSelectedCity("");
    setShowLocationModal(false);
    setCitySearch("");
    setSearchResults([]);
    setShowAllCities(false);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleViewAllCities = () => {
    if (!showAllCities && allCities.length === 0) {
      fetch(`${API_BASE_URL}/getCities`)
        .then((res) => res.json())
        .then((data) => {
          if (data?.status === "success") setAllCities(data.data);
        })
        .catch((err) => console.error("All cities error:", err));
    }
    setShowAllCities((prev) => !prev);
  };

  const cityDisplayLabel = selectedCity || "All Cities";

  const handleSearch = () => {
    if (!searchText.trim()) return;

    navigate(`/search?keyword=${encodeURIComponent(searchText)}`);
  };

  return (
    <>
      <header className="landing-header">
        <div className="container p-0">
          <div className="header-top">
            <div className="wrapper">
              <Link to="/">
                <div className="logo">
                  <img
                    // src="/eventfork_logo.svg"
                    src="/eventfork_logo.svg"
                    alt="EventFork"
                    height="90"
                    width="200"
                  />
                </div>
              </Link>

              {/* Select city dropdown */}
              {isHomePage && (
                <div
                  className="select-wrapper"
                  onClick={() => setShowLocationModal(true)}
                >
                  <div
                    className="form-select home-city-select"
                    style={{ cursor: "pointer" }}
                  >
                    <span>{cityDisplayLabel}</span>
                  </div>
                </div>
              )}

              <i
                className={`fa-solid ${mobileMenuOpen ? "fa-xmark" : "fa-bars"
                  } mobile-menu-btn ${mobileMenuOpen ? "open" : ""}`}
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              ></i>

            </div>

            <div className="header-buttons">
              {/* Global search box */}
              <div className="input-wrapper">
                <img src={searchicon} alt="search icon" />
                <input
                  className="form-control me-2 home-search"
                  type="search"
                  placeholder="Search events..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onFocus={() => {
                    if (eventResults.length) setShowSearchDropdown(true);
                  }}
                />


                {showSearchDropdown && (
                  <div className="search-dropdown">

                    {searchLoading ? (
                      <div className="search-loading">Searching...</div>
                    ) : eventResults.length === 0 ? (
                      <div className="search-empty">No events found</div>
                    ) : (
                      eventResults.map((event) => (
  <div
    key={event.metadata.event_id}
    className="search-item"
   onClick={() => {
  setSearchText("");
  setShowSearchDropdown(false);
  setMobileMenuOpen(false);   // Close hamburger menu
  navigate(`/eventpage/${event.metadata.event_id}`);
}}
  >
    <h5>{event.metadata.name}</h5>

    <p>{event.metadata.city}</p>
  </div>
))
                    )}

                  </div>
                )}
              </div>

              <button
                type="button"
                className="btn btn-create create-event-btn"
                onClick={handleCreateEvent}
              >
                <img
                  src={createPlusicon}
                  alt="Create plus icon"
                  width={"16px"}
                />{" "}
                Create Event
              </button>

              <button
                type="button"
                className="btn btn-secondary login-btn"
                onClick={handleSignIn}
              >
                Log In
              </button>
            </div>
          </div>
          <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>

            <div className="input-wrapper">
              <img src={searchicon} alt="" />
              <input
  className="form-control home-search"
  type="search"
  placeholder="Search events..."
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
  onFocus={() => {
    if (eventResults.length) {
      setShowSearchDropdown(true);
    }
  }}
/>
{showSearchDropdown && (
  <div className="search-dropdown">
    {searchLoading ? (
      <div className="search-loading">
        Searching...
      </div>
    ) : eventResults.length === 0 ? (
      <div className="search-empty">
        No events found
      </div>
    ) : (
      eventResults.map((event) => (
        <div
          key={event.metadata.event_id}
          className="search-item"
          onClick={() => {
            setSearchText("");
            setShowSearchDropdown(false);
             setMobileMenuOpen(false); 
            navigate(`/eventpage/${event.metadata.event_id}`);
          }}
        >
          <h5>{event.metadata.name}</h5>
          <p>{event.metadata.city}</p>
        </div>
      ))
    )}
  </div>
)}
            </div>

            <div className="menu-buttons">

              <button
                className="btn btn-create create-event-btn"
                onClick={handleCreateEvent}
              >
                Create Event
              </button>

              <button
                className="btn btn-secondary login-btn"
                onClick={handleSignIn}
              >
                Log In
              </button>

            </div>

          </div>



        </div>
      </header>

      {showLocationModal && (
        <div className="location-backdrop">
          <div className="modal-wrapper slide-top" ref={modalRef}>
            <div className="container">
              <div className="input-wrapper" style={{ position: "relative" }}>
                <img src={searchicon} alt="search icon" />

               <input
                  className="form-control search-location"
                  type="search"
                  placeholder="Search for your city"
                  value={citySearch}
                  onChange={(e) => setCitySearch(e.target.value)}
                  autoFocus
                />



                {/* search results dropdown */}
                {searchResults.length > 0 && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: "0px",
                      listStyle: "none",
                      padding: "0px",
                      margin: 0,
                      zIndex: 9999,
                      maxHeight: "470px",
                      overflowY: "auto",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      borderTop: "none",
                      borderBottom: "none",
                    }}
                  >
                    {searchResults.map((city, idx) => {
                      const query = citySearch;
                      const name = city.city_name;
                      const matchIdx = name
                        .toLowerCase()
                        .indexOf(query.toLowerCase());
                      const isFirst = idx === 0;

                      return (
                        <li
                          key={city.id}
                          onClick={() => handleSelectCity(city.city_name)}
                          style={{
                            cursor: "pointer",
                            padding: "10px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                            borderBottom: "1px solid #dee2e6",
                            textAlign: "left",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f5f5f5")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <span>
                            <img
                              src={locationIcon}
                              alt="location-icon"
                              style={{ position: "static" }}
                            />
                          </span>
                          <span>
                            {matchIdx >= 0 ? (
                              <>
                                {name.substring(0, matchIdx)}
                                <strong>
                                  {name.substring(
                                    matchIdx,
                                    matchIdx + query.length,
                                  )}
                                </strong>
                                {isFirst ? (
                                  <span>
                                    {name.substring(matchIdx + query.length)}
                                  </span>
                                ) : (
                                  name.substring(matchIdx + query.length)
                                )}
                              </>
                            ) : (
                              name
                            )}
                            <p
                              style={{
                                color: "#1a202c",
                                fontSize: "0.82em",
                                margin: "0px",
                              }}
                            >
                              {city.state_name}
                            </p>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
              <div className="detect-wrap">
                <p className="detect-location">
                  <img src={detecticon} alt="detect icon" />
                  <span>Detect my location</span>
                </p>
                <p className="all-cities" onClick={handleAllCities}>
                  All Cities
                </p>
              </div>
            </div>

            <div className="popular-cities">
              <h4>Popular Cities</h4>
              <ul>
                {cities.map((city) => (
                  <li
                    key={city.id}
                    onClick={() => handleSelectCity(city.name)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={city.imagesrc} alt={city.name} />
                    <p>{city.name}</p>
                  </li>
                ))}
              </ul>
            </div>


            <button className="view-all-btn" onClick={handleViewAllCities}>
              {showAllCities ? "Hide All Cities" : "View All Cities"}
            </button>

            {/* all cities 5-column grid */}
            {showAllCities && (
              <div className="all-city-wrap">
                <p
                  style={{
                    textAlign: "center",
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "300",
                  }}
                >
                  Other Cities
                </p>
                <div
                  className="all-city"
                >
                  {allCities.map((city) => (
                    <div
                      key={city.id}
                      className="city-item"
                      onClick={() => handleSelectCity(city.city_name)}
                    >
                      <i className="fas fa-city"></i>
                      <span>{city.city_name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Location updated toast */}
      {showToast && (
        <>
          <style>{`
            @keyframes toastFadeInOut {
              0%   { opacity: 0; transform: translateX(-50%) translateY(10px); }
              15%  { opacity: 1; transform: translateX(-50%) translateY(0); }
              75%  { opacity: 1; transform: translateX(-50%) translateY(0); }
              100% { opacity: 0; transform: translateX(-50%) translateY(10px); }
            }
          `}</style>
          <div
            style={{
              position: "fixed",
              top: "90px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#9a1a04ff",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "14px",
              fontWeight: 500,
              zIndex: 99999,
              boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
              animation: "toastFadeInOut 3s ease forwards",
              whiteSpace: "nowrap",
            }}
          >
            <span className="location-toast">
              <img src={locationIcon} alt="location-icon" />
            </span>
            {selectedCity
              ? `Your location is updated to ${selectedCity}.`
              : "Showing events from all cities."}
          </div>
        </>
      )}
    </>
  );
};

export default MainHeader;
